import { HttpClient, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelper } from './auth.utils';
import { AuthService } from './auth.service';

const jwtHelper = new JwtHelper();

/**
 * Prevents sending the http-request to backend
 */
const ignoreRequest: HttpHandler = {
  handle(_: HttpRequest<any>): Observable<HttpEvent<any>> {
    return new Observable(subscriber => {
      subscriber.error(new HttpResponse({statusText: `Request wasn't sent due to missing required UI rights`, status: 401}));
      subscriber.complete();
    });
  }
};

/**
 * Can be used to prevent sending http-requests from services that user has no rights to.
 */
export const checkUIPermissionsFactory = (S: any, uiRights: string[], ...deps: any[]) => {
  // find AuthService indirectly to ensure constructor parameter order is retained
  const authService: AuthService = deps.find(dep => dep instanceof AuthService);
  if (!authService) {
    throw new Error('checkUIPermissionsFactory requires AuthService in the deps array!');
  }

  const modifiedDependencies = deps.map(dep => {
    if (dep instanceof HttpClient) {
      const hasPermission = uiRights.some(right => authService.hasPermission(right));
      // If the user has the UI permission, use the normal http-client. Else use client, which ignores the requests.
      return hasPermission ? dep : new HttpClient(ignoreRequest);
    } else {
      return dep;
    }
  });
  return new S(...modifiedDependencies);
};
